"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Select = _interopRequireDefault(require("../Select/Select"));
var _Checkbox = _interopRequireDefault(require("../../components/Checkbox/Checkbox"));
var _generateThemeClassName = _interopRequireDefault(require("../../utils/generateThemeClassName"));
require("./FilterHero.scss");
var _generateID = _interopRequireDefault(require("../../utils/generateID"));
var _checkForDangerouslySet = _interopRequireDefault(require("../../utils/checkForDangerouslySet"));
var _FilterHeroMethods = require("./FilterHeroMethods");
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _useStyles = _interopRequireDefault(require("../../utils/hooks/useStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FilterHero = _ref => {
  let {
    header,
    text,
    dropdowns,
    checkboxes,
    id,
    handleDropdownSelect,
    handleCheckboxChange,
    theme
  } = _ref;
  const [state, setState] = (0, _react.useState)({});
  const themes = (0, _checkForThemeProps.checkForThemeProps)(theme);
  const {
    backgroundColor,
    color
  } = (0, _useStyles.default)(themes);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-filter-hero",
    style: {
      backgroundColor: backgroundColor
    }
    // id={generateID(id, header)}
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-hero__header-section"
  }, header && /*#__PURE__*/_react.default.createElement("h3", {
    className: "ter-filter-hero__header",
    style: {
      color: color
    }
  }, header), text && !(0, _checkForDangerouslySet.default)(text) && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-filter-hero__text",
    style: {
      color: color
    }
  }, text), text && (0, _checkForDangerouslySet.default)(text) && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-hero__text-holder dangerously-set-content",
    style: {
      color: color
    },
    dangerouslySetInnerHTML: {
      __html: text
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-hero__dropdown-container"
  }, dropdowns && (0, _FilterHeroMethods.generateDropdowns)(dropdowns, state, setState, handleDropdownSelect, color), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-filter-hero__checkbox-container"
  }, checkboxes && (0, _FilterHeroMethods.generateCheckboxes)(checkboxes, state, setState, handleCheckboxChange, color))));
};
var _default = FilterHero;
exports.default = _default;